<section>
  <ng-template #leftColumn>
    <div class="profile-information block">
      <div class="d-flex flex-column align-items-center profile-top">
        <div class="background"></div>
        <div class="profile-avatar">
          <div class="avatar rounded-circle">
            <img [src]="club.icon | baseUrl" alt="profile-name" class="img-fluid" />
          </div>
        </div>
        <div class="profile-name d-flex align-items-center">
          {{ club.name }}
          <div class="icon verified" *ngIf="club.confirmed">
            <svg viewBox="0 0 20 20">
              <use href="#new-verified" />
            </svg>
          </div>
        </div>
        <div class="profile-verified" *ngIf="club.confirmed">Verified Organization</div>
        <div class="profile-actions d-flex" *appHideForGuest>
          <ng-container *ngIf="club.is_autor; else not_admin">
            <button class="action d-flex align-items-center justify-content-center" (click)="onEdit(); false">
              <span class="icon">
                <svg viewBox="0 0 18 20">
                  <use href="#new-edit-info"></use>
                </svg>
              </span>
              <div>Edit information</div>
            </button>
            <button class="action d-flex align-items-center justify-content-center" (click)="onOpenInviteDialog()">
              <span class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#new-invite"></use>
                </svg>
              </span>
              <div>Invite</div>
            </button>
          </ng-container>

          <ng-template #not_admin>
            <ng-container [ngSwitch]="true">
              <button
                class="action d-flex align-items-center justify-content-center"
                *ngSwitchCase="club.is_subscriber"
                (click)="onLeave(); false"
              >
                <span class="icon">
                  <svg viewBox="0 0 18 20">
                    <use href="#new-exit"></use>
                  </svg>
                </span>
                <div>Leave Club</div>
              </button>

              <button
                class="action d-flex align-items-center justify-content-center"
                *ngSwitchCase="club.is_requested"
                (click)="onCallOff(); false"
              >
                <span class="icon">
                  <svg viewBox="0 0 18 20">
                    <use href="#new-exit"></use>
                  </svg>
                </span>
                <div>Call off</div>
              </button>

              <button
                class="action d-flex align-items-center justify-content-center"
                *ngSwitchDefault
                (click)="onJoin(); false"
              >
                <span class="icon">
                  <svg viewBox="0 0 18 20">
                    <use href="#new-join"></use>
                  </svg>
                </span>
                <div>Join Club</div>
              </button>
            </ng-container>

            <button
              class="action d-flex align-items-center justify-content-center"
              (click)="onOpenMessageDialog(); false"
            >
              <span class="icon">
                <svg viewBox="0 0 18 20">
                  <use href="#new-edit"></use>
                </svg>
              </span>
              <div>Contact Club</div>
            </button>
          </ng-template>
        </div>
      </div>
      <div class="club-contacts">
        <ng-container *ngIf="club.body; let body">
          <div class="club-contacts-item d-flex">
            <div class="avatar rounded-circle">
              <app-avatar
                [src]="body.users[0]?.icon"
                [placeholder]="(body.users[0] || { name: body.name }) | initials"
                class="img-fluid"
              >
              </app-avatar>
            </div>
            <div class="data">
              <div class="position">Associated school</div>
              <div class="name">{{ body.name }}</div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="club.org; let org">
          <div class="club-contacts-item d-flex">
            <div class="avatar rounded-circle">
              <app-avatar
                [src]="org.users[0]?.icon"
                [placeholder]="(org.users[0] || { name: org.name }) | initials"
                class="img-fluid"
              >
              </app-avatar>
            </div>
            <div class="data">
              <div class="position">Main organization</div>
              <div class="name">{{ org.name }}</div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="enumerations">
        <div class="enumeration-item d-flex">
          <app-location
            [isShowLogo]="true"
            [prefix]="'Located in'"
            [city]="club.location?.city?.name"
            [country]="club.location?.country?.name"
          ></app-location>
        </div>
        <div class="enumeration-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#new-members" />
            </svg>
          </div>
          <span>Members <a href="#">{{ club.members }}</a></span>
        </div>
      </div>
      <div class="about-block">
        <div class="title">About club</div>
        <div> {{ club.description }} </div>
      </div>
      <div class="about-block" *ngIf="club.link">
        <div class="title">How to get involved</div>
        {{ club.link }}
      </div>
    </div>

    <!-- <div class="extra-block block">
        <div class="title">Similar clubs</div>
        <div class="club-list d-lg-flex flex-lg-wrap justify-content-between">
          <div class="club-item">
            <div class="logo">
              <img src="/assets/new_img/image%206.png" class="img-fluid">
            </div>
            <div class="title">
              Yale Young Global Scholars
            </div>
            <div class="extra">Finance • 751 members</div>
            <a href="#" class="link">Join club</a>
          </div>
          <div class="club-item">
            <div class="logo">
              <img src="/assets/new_img/image%206.png" class="img-fluid">
            </div>
            <div class="title">
              Yale Young Global Scholars
            </div>
            <div class="extra">Finance • 751 members</div>
            <a href="#" class="link">Join club</a>
          </div>
          <div class="club-item">
            <div class="logo">
              <img src="/assets/new_img/image%206.png" class="img-fluid">
            </div>
            <div class="title">
              Yale Young Global Scholars
            </div>
            <div class="extra">Finance • 751 members</div>
            <a href="#" class="link">Join club</a>
          </div>
          <div class="club-item">
            <div class="logo">
              <img src="/assets/new_img/image%206.png" class="img-fluid">
            </div>
            <div class="title">
              Yale Young Global Scholars
            </div>
            <div class="extra">Finance • 751 members</div>
            <a href="#" class="link">Join club</a>
          </div>
        </div>
        <button class="btn more">More clubs</button>
      </div> -->
  </ng-template>

  <div class="container d-flex">
    <div class="left-column d-none d-md-block">
      <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
    </div>
    <div class="middle-column d-block">
      <mat-tab-group
        animationDuration="0ms"
        [selectedIndex]="mapSectionToIndex(section$ | async)"
        (selectedTabChange)="tabChanged($event)"
      >
        <mat-tab [label]="sections.Updates">
          <ng-template mat-tab-label>
            <div class="custom-tab">What's new</div>
          </ng-template>

          <ng-template matTabContent>
            <div class="d-md-none">
              <ng-container *ngTemplateOutlet="leftColumn"></ng-container>
            </div>
            <div class="add-post-block block" *ngIf="canMakePosts">
              <app-message [ctx]="messageCtx" class="message"></app-message>
            </div>
            <app-posts
              [posts]="posts$ | async"
              [ctx]="postsCtx"
              [isClubPost]="true"
              [isPrivateGroup]="(club.access === 3)"
              [isSubscriber]="club.is_subscriber"
              [hideMargin]="!(club.is_autor || club.is_editor || club.is_subscriber)"
            ></app-posts>
          </ng-template>
        </mat-tab>

        <mat-tab [label]="sections.Members" [disabled]="!isAuthorized || !club.members">
          <ng-template mat-tab-label>
            <div class="custom-tab">Members <div *ngIf="club.members">({{ club.members }})</div> </div>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-body-top">
              <h3>Members</h3>
              <div class="job-search">
                <input
                  type="text"
                  [value]="search$ | async"
                  (keydown.enter)="onSearch($event.target.value)"
                  placeholder="Search contact..."
                />
                <button>
                  <svg viewBox="0 0 18 18">
                    <use href="#search" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="block">
              <ng-container *ngIf="(members$ | async) as members">
                <app-loader-2 *ngIf="members.loadMembers; else membersList"></app-loader-2>
                <ng-template #membersList>
                  <app-club-members
                    [members]="members?.members"
                    (connect)="onProfileConnect($event)"
                    (disconnect)="onProfileDisconnect($event)"
                  ></app-club-members>
                </ng-template>
                <div class="d-flex justify-content-center justify-content-md-end mt-md-auto mr-md-3 mb-3">
                  <app-page-counter
                    *ngIf="members.amountOfPages"
                    [currentPage]="page$ | async"
                    [amountOfPages]="members.amountOfPages"
                    (setPage)="onSetPage($event)"
                    class="mt-md-auto"
                  >
                  </app-page-counter>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </mat-tab>

        <mat-tab [label]="sections.Resources" *ngIf="(club.is_autor || club.is_editor || club.is_subscriber)">
          <ng-template mat-tab-label>
            <div class="custom-tab" matBadgeSize="small">Resources</div>
          </ng-template>

          <ng-template matTabContent>
            <div class="add-post-block block" *ngIf="canMakeResource">
              <app-message [ctx]="resourcesMessageCtx" class="message"></app-message>
            </div>

            <app-posts
              [posts]="resources$ | async"
              [ctx]="resourcesPostCtx"
              [isResource]="true"
              [isPrivateGroup]="(club.access === 3)"
              [isSubscriber]="club.is_subscriber"
              [hideMargin]="!(club.is_autor || club.is_editor || club.is_subscriber)"
            ></app-posts>
          </ng-template>
        </mat-tab>

        <mat-tab [label]="sections.Media" *ngIf="club.access !== 3">
          <ng-template mat-tab-label>
            <div class="custom-tab" matBadgeSize="small">Media</div>
          </ng-template>

          <ng-template matTabContent>
            <div class="tab-body-top d-flex">
              <h3>Media</h3>
              <div class="filter d-flex align-items-center">
                <span>Filter:</span>
                <div class="select-wrap">
                  <select [ngModel]="selectedMediaType$ | async" (ngModelChange)="onChangeMediaFilterType($event)">
                    <option [ngValue]="'photos'">Photos</option>
                    <!-- <option [ngValue]="'videos'">Videos</option> -->
                    <option [ngValue]="'files'">Files</option>
                  </select>
                </div>
              </div>
            </div>

            <ng-container [ngSwitch]="selectedMediaType$ | async">
              <app-club-media-photos
                *ngSwitchCase="mediaTypes.Photos"
                [canAddPhoto]="club.can_post_resource"
                [photos]="mediaPhotos$ | async"
                (loadMore)="onLoadMorePhotos()"
                (selectPhoto)="onSelectPhoto($event)"
                (removePhoto)="onRemovePhoto($event)"
              ></app-club-media-photos>
              <app-club-media-videos *ngSwitchCase="mediaTypes.Videos" [videos]="[]"></app-club-media-videos>
              <app-club-media-files
                *ngSwitchCase="mediaTypes.Files"
                [files]="mediaFiles$ | async"
                [canAddFile]="club.can_post_resource"
                (selectFile)="onSelectFile($event)"
                (removeFile)="onRemoveFile($event)"
              ></app-club-media-files>
              <!-- TODO: -->
              <app-club-media-photos *ngSwitchDefault [photos]="mediaPhotos$ | async"></app-club-media-photos>
            </ng-container>
          </ng-template>
        </mat-tab>

        <mat-tab [label]="sections.Requests" *ngIf="club.is_autor" [disabled]="club.requests_count <= 0">
          <ng-template mat-tab-label>
            <div class="custom-tab">Requests <div *ngIf="club.members">({{ club.requests_count }})</div> </div>
          </ng-template>
          <ng-template matTabContent>
            <div class="tab-body-top">
              <h3>Requests</h3>
              <!-- <div class="job-search">
              <input type="text" [value]="search$ | async" (keydown.enter)="onSearch($event.target.value)"
                placeholder="Search contact...">
              <button>
                <svg viewBox="0 0 18 18">
                  <use href="#search" />
                </svg>
              </button>
            </div> -->
            </div>
            <div class="block">
              <ng-container *ngIf="(requests$ | async) as requests">
                <app-loader-2 *ngIf="requests.loadRequests; else requestsList"></app-loader-2>
                <ng-template #requestsList>
                  <!-- {{ requests?.requests | json }} -->
                  <app-club-requests
                    [requests]="requests?.requests"
                    (accept)="onAcceptRequest($event)"
                    (reject)="onRejectRequest($event)"
                  ></app-club-requests>
                </ng-template>
                <div class="d-flex justify-content-center justify-content-md-end mt-md-auto mr-md-3 mb-3">
                  <app-page-counter
                    *ngIf="requests.amountOfPages"
                    [currentPage]="page$ | async"
                    [amountOfPages]="requests.amountOfPages"
                    (setPage)="onSetPage($event)"
                    class="mt-md-auto"
                  >
                  </app-page-counter>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</section>
